import { motion } from "framer-motion";
import { CHAPTERS, IMAGES } from "./data";

const EASE = [0.16, 1, 0.3, 1];

export default function Philosophy() {
  return (
    <section id="philosophy" className="bg-moss text-[#F9F6F0] py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: EASE }}
            className="lg:col-span-8"
          >
            <p className="text-xs uppercase tracking-[0.25em] text-gold font-semibold mb-6">
              Our Clinical Philosophy
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-snug">
              We treat skin like it matters.
              <span className="italic text-gold"> Because it does.</span>
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15, ease: EASE }}
            className="lg:col-span-4 text-sm text-[#F9F6F0]/60 leading-relaxed"
          >
            Three principles guide every consultation, every treatment plan and
            every honest conversation at Luviae.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-10 lg:gap-14">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.number}
              data-testid={`philosophy-chapter-${c.number}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.15, ease: EASE }}
              className="border-t border-[#F9F6F0]/15 pt-8"
            >
              <span className="font-serif text-6xl font-light text-clay/70">
                {c.number}
              </span>
              <h3 className="font-serif text-2xl font-normal mt-6 mb-4">
                {c.title}
              </h3>
              <p className="text-sm text-[#F9F6F0]/60 leading-relaxed">{c.desc}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: EASE }}
          className="mt-24 relative rounded-[2rem] overflow-hidden aspect-[16/7] max-h-[70vh]"
        >
          <img
            src={IMAGES.sanctuary}
            alt="The calm treatment sanctuary at Luviae Aesthetics"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-moss/40" />
          <p className="absolute bottom-8 left-8 right-8 font-serif text-2xl sm:text-3xl font-light italic text-[#F9F6F0] max-w-2xl leading-snug">
            "A clinic should feel like an exhale — not a transaction."
          </p>
        </motion.div>
      </div>
    </section>
  );
}
